<nb-card class="spatial-container">
    <!-- Card header -->
    <nb-card-header>
        <div class="spatial-header">
            <div class="title">
                {{ title }}
            </div>
        </div>
    </nb-card-header>

    <!-- Body: map and map components -->
    <nb-card-body>
        <div #mapViewNode class="map-container" id="viewDiv">
            <div *ngIf="legendBuckets$ | async as legendBuckets">
                <ngx-spatial-card-category-filters
                    [categoryList]="legendBuckets"
                    [selectInLegend]="!!ownershipFilter"
                    [form]="ownershipForm"
                ></ngx-spatial-card-category-filters>
            </div>
        </div>
    </nb-card-body>
</nb-card>
